define([
  'lib/sumome/service/index',
  'articles',
  'moment',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/scrollbox/popup',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/clicktriggers',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/displayrules',
], (SumoService, Articles, moment, ScrollBoxPopup, MainService, ClickTriggers, DisplayRules) => {

  class ScrollBoxService extends SumoService.Service {
    static SHOWN_COOKIE = '__smScrollBoxShown';
    static OPT_OUT_COOKIE = '__smScrollBoxOptOut';

    constructor(api, service, scrollbox, opts = {}) {
      super(api);
      if (scrollbox && opts.isPreview) {
        this.scrollbox = new ScrollBoxPopup(this, {
          ...scrollbox,
          isPreview: true,
        });

        return this.onShow(null, this.scrollbox);
      }

      this.fetchFeatures().then(() => {
        this.scrollTop = -1;
        this.scrollbox = null;

        this.onShow = this.onShow.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.triggerPercent = scrollbox.trigger_percent;
        this.scrollbox = new ScrollBoxPopup(this, scrollbox);
        this.addEvent(window, 'scroll', this.onScroll);

        // Cookie function initializations
        this.setOptOutCookie = service.setOptOutCookie.bind(this, ScrollBoxService.OPT_OUT_COOKIE);
        this.setShownCookie = service.setShownCookie.bind(this, ScrollBoxService.SHOWN_COOKIE);
        this.setCtaCookie = service.setCtaCookie.bind(this);
        this.setSubscribedCookie = service.setSubscribedCookie.bind(this);
        this.setPushSubscribedCookie = service.setPushSubscribedCookie.bind(this);

        this.scrollElement = document.body;

        if (Math.max(
          document.documentElement.scrollHeight,
          document.body.scrollHeight,
        ) <= window.innerHeight) {
          // No where to scroll, find a possible scrollElement
          const elements = document.querySelectorAll('*');
          for (let i = 0; i < elements.length && this.scrollElement === document.body; i++) {
            if (elements[i].scrollHeight > window.innerHeight) {
              this.scrollElement = elements[i];
            }
          }
        }
      });
    }

    onShow() {
      this.scrollbox.show();
    }

    onScroll(e) {
      let scrollTop = this.scrollElement.scrollTop || document.documentElement.scrollTop;
      const winHeight = window.innerHeight;
      const docHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      const bottom = docHeight - winHeight;
      const threshold = Math.min(100, Math.max(0, (this.triggerPercent / 100)));
      const perc = Math.max(0, Math.min(1, scrollTop / bottom));

      if (perc >= threshold) {
        this.removeEvent(window, 'scroll', this.onScroll);
        this.onShow();
      }
    }
  }

  return ScrollBoxService;
});
